<template>
    <gi-form
        v-if="form"
        ref="form"
        :form="form"
        :on-submit-fn="onSubmitFn"
        :history="history"
        :hide-actions="hideActions"
        @success="onSuccess"
        @error="onError"
        @form-error="onFormError"
        @load-history="onLoadHistory"
        @start-history-autosave="startHistoryAutosave"
        @stop-history-autosave="stopHistoryAutosave"
    >
        <template v-if="!hideHeader" #header>
            <app-page-header class="mb-4" />
        </template>
        <template #fields="{ loading }">
            <field-enum
                v-model="form.type"
                :disabled="loading"
                :enums="ActivityTypeEnum"
                enum-a11y-key="enums.activity_type"
                :label="$t('type')"
                required
            />
            <field-icon ref="icon" v-model="form.icon" :disabled="loading" :label="$t('icon')" required />
            <field-date ref="date" v-model="form.date" :disabled="loading" :label="$t('date')" required />
            <field-string ref="title" v-model="form.title" :disabled="loading" :label="$t('title')" required />
            <field-description ref="text" v-model="form.text" :disabled="loading" :label="$t('text')" required />
            <field-enum
                v-model="form.scope"
                :disabled="loading"
                :enums="ActivityScopeEnum"
                enum-a11y-key="enums.activity_scope"
                :label="$t('scope')"
                required
            />
            <field-toggle
                ref="todo"
                v-model="form.todo"
                :disabled="loading"
                :label="$t('todo')"
                :default-value="null"
            />

            <v-row :no-gutters="$vuetify.breakpoint.smAndDown" class="stacked">
                <v-col md="3" cols="12">
                    <field-enum
                        v-model="form.alert_type"
                        :disabled="loading"
                        :enums="AlertTypeEnum"
                        enum-a11y-key="enums.alert_type"
                        :label="$t('alert_type')"
                    />
                </v-col>
                <v-col md="9" cols="12">
                    <field-string
                        ref="alert_text"
                        v-model="form.alert_text"
                        :disabled="loading"
                        :label="$t('alert_text')"
                    />
                </v-col>
            </v-row>

            <field-investor ref="investor_id" v-model="form.investor_id" :disabled="loading" allow-create />
            <field-adviser ref="adviser_id" v-model="form.adviser_id" :disabled="loading" allow-create />
            <field-offer ref="offer_id" v-model="form.offer_id" :disabled="loading" allow-create />
            <field-product ref="product_id" v-model="form.product_id" :disabled="loading" allow-create />
            <field-transaction ref="transaction_id" v-model="form.transaction_id" :disabled="loading" allow-create />
            <field-proposal ref="proposal_id" v-model="form.proposal_id" :disabled="loading" allow-create />
            <field-fund ref="fund_id" v-model="form.fund_id" :disabled="loading" allow-create />

            <template v-if="form.details">
                <h4 class="text-h4">{{ $t('details') }}</h4>
                <app-table-nested :value="form.details" />
            </template>
        </template>
        <template v-if="prependCancelButton" #prepend-actions>
            <app-button-cancel @click="onCancel" />
        </template>
    </gi-form>
</template>

<script>
import form from '@/mixins/form';
import history from '@/mixins/history';
import { Activity } from '@/models';
import ActivityScopeEnum from '@/enums/activity/scope';
import ActivityTypeEnum from '@/enums/activity/type';
import AlertTypeEnum from '@/enums/alert/type';

export default {
    name: 'CreateActivity',
    components: {
        GiForm: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/forms/Form'
            ),
        FieldIcon: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/Icon'
            ),
        FieldInvestor: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/Investor'
            ),
        FieldAdviser: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/Adviser'
            ),
        FieldOffer: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/Offer'
            ),
        FieldProduct: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/Product'
            ),
        FieldTransaction: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/Transaction'
            ),
        FieldProposal: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/Proposal'
            ),
        FieldFund: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/Fund'
            ),
        AppTableNested: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/table/AppTableNested'
            )
    },
    mixins: [form, history],
    data: () => ({
        id: 'CreateActivity',
        model: Activity,
        ActivityTypeEnum,
        ActivityScopeEnum,
        AlertTypeEnum
    })
};
</script>
